<div class="_breadcrumb">
  <div class="_back" (click)="back()">
    <svg
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.00168252 7.05373C0.0141618 7.22691 0.0825002 7.39158 0.196588 7.52039L5.67317 13.7425C5.80807 13.8956 5.99704 13.988 6.19848 13.9989C6.39993 14.0098 6.59782 13.9387 6.74757 13.8008C6.89792 13.6629 6.98824 13.4697 6.99893 13.2637C7.00963 13.0571 6.93951 12.8554 6.80462 12.7022L1.78442 7.0003L6.80462 1.29837C6.93951 1.14464 7.00964 0.942901 6.99893 0.736918C6.98822 0.530936 6.89791 0.337708 6.74757 0.19978C6.59782 0.0618486 6.39993 -0.00985795 6.19848 0.00109295C5.99704 0.0120303 5.80806 0.104389 5.67317 0.258112L0.196588 6.48021C0.0581279 6.63637 -0.0119937 6.84357 0.00168252 7.05381V7.05373Z"
        fill="#DA366C"
      />
    </svg>

    <span>Back</span>
    <div>|</div>
  </div>
  <ng-container
    *ngFor="let item of pathArray; let i = index; let isLast = last"
  >
    <span class="_link" [class._last]="isLast" (click)="navigateTo(i)">
      {{ item.title }}
    </span>
    <ng-container *ngIf="!isLast">/</ng-container>
  </ng-container>
</div>
